/* eslint-disable react-hooks/rules-of-hooks */
import { Step, StepConnector, StepLabel, Stepper, styled } from '@mui/material'
import { Colors, Shapes, Typographies, useTypography } from 'src/components/theme'

const StyledStep = styled(Step)`
  padding: 0;
  .MuiStepLabel-label {
    ${useTypography(Typographies.textmd)}
    margin-top: ${Shapes.spacing[2]}px;
  }
  .MuiStepLabel-label.Mui-active,
  .MuiStepLabel-label.Mui-completed {
    color: ${Colors.blueDark};
  }
`
const StyledStepLabel = styled(StepLabel)`
  .MuiStepLabel-iconContainer {
    position: relative;
    svg {
      height: ${Shapes.spacing[5]}px;
      width: ${Shapes.spacing[5]}px;
      text {
        position: absolute;
        transform: translateY(-1px);
        ${useTypography(Typographies.title2)}
      }
    }
  }
  .Mui-active,
  .Mui-completed {
    svg {
      color: ${Colors.blueDark};
    }
  }
  .Mui-disabled {
    svg {
      color: ${Colors.textLight};
    }
  }
`
const StyledStepConnector = styled(StepConnector)`
  .MuiStepConnector-line {
    border-width: 2px;
  }
  &.Mui-disabled,
  &.Mui-active,
  &.Mui-completed {
    left: calc(-50% + 12px);
    right: calc(50% + 12px);
  }
  &.Mui-disabled > .MuiStepConnector-line {
    border-color: ${Colors.border};
  }
  &.Mui-active > .MuiStepConnector-line,
  &.Mui-completed > .MuiStepConnector-line {
    border-color: ${Colors.blueDark};
  }
`

type StepsProps = {
  activeStep: number
  steps: string[]
}
export const Steps = (props: StepsProps) => {
  const { activeStep, steps } = props

  return (
    <Stepper activeStep={activeStep} alternativeLabel connector={<StyledStepConnector />}>
      {steps.map((step) => {
        return (
          <StyledStep key={step} completed={activeStep > steps.indexOf(step) || activeStep === steps.length - 1}>
            <StyledStepLabel>{step}</StyledStepLabel>
          </StyledStep>
        )
      })}
    </Stepper>
  )
}
